import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from 'react-apollo-hooks';
import { Rehydrated } from 'aws-appsync-react';
import AppSyncClient from 'config/AppSyncClient';

const WithApolloProvider = ({ children, config }) => {
  const client = AppSyncClient(config);

  return (
    <ApolloProvider client={client}>
      <ApolloHooksProvider client={client}>
        <Rehydrated>{children}</Rehydrated>
      </ApolloHooksProvider>
    </ApolloProvider>
  );
};

export default WithApolloProvider;
